import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ITableServerFilter } from 'src/app/common/interfaces/table/table-server-filter.inteface';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { IReturnInitiate } from '../../interfaces/return-list/return-initiate.interface';
import { IRtpInitiatedReturnList } from '../../interfaces/initiated-return/rtp-initiated-return-list.interface';
import { IRtpInitiatedReturnDetails } from '../../interfaces/initiated-return/rtp-initiated-return-detail.interface';
import { AbstractRtpReturnInitiatedService } from '../abstraction/abstract.rtp-return-initiated.service';

@Injectable({
  providedIn: 'root',
})
export class MockRtpReturnInitiatedService extends AbstractRtpReturnInitiatedService {
  private tableFilterJson = 'assets/mocks/rtp/returninitiated/tableFilter.json';
  private getDetailApprovedJson = 'assets/mocks/rtp/returninitiated/getDetailApproved.json';
  private getDetailDeniedJson = 'assets/mocks/rtp/returninitiated/getDetailDenied.json';
  private getDetailOrphanJson = 'assets/mocks/rtp/returninitiated/getDetailOrphan.json';
  private getDetailInitiatedJson = 'assets/mocks/rtp/returninitiated/getDetailInitiated.json';
  private reasonInitiateReturnListJson =
    'assets/mocks/rtp/returninitiated/reasonInitiateReturnList.json';
  private fraudClassifierListJson = 'assets/mocks/rtp/returninitiated/fraudClassifierList.json';
  private initiateJson = 'assets/mocks/rtp/returninitiated/initiate.json';

  constructor(private http: HttpClient) {
    super();
  }

  tableFilter(filter: ITableServerFilter): Promise<ITableServerResponseFilter | undefined> {
    return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.tableFilterJson));
  }

  tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }

  tableExportExcel(filter: ITableServerFilter): Promise<any | undefined> {
    throw new Error('Method not implemented.');
  }

  tableFilterSingleRecordById(
    rtpUniqueMessageId: string
  ): Promise<IRtpInitiatedReturnList | undefined> {
    throw new Error('Method not implemented.');
  }

  async getDetail(rtpUniqueMessageId: string): Promise<IRtpInitiatedReturnDetails | undefined> {
    const list = await lastValueFrom(
      this.http.get<ITableServerResponseFilter>(this.tableFilterJson)
    );
    const original = list?.queryable.find((x: any) => x.rtpUniqueMessageId === rtpUniqueMessageId);

    if (original?.returnStatus === 'Return Approved') {
      return lastValueFrom(this.http.get<IRtpInitiatedReturnDetails>(this.getDetailApprovedJson));
    }
    if (original?.returnStatus === 'Return Denied') {
      return lastValueFrom(this.http.get<IRtpInitiatedReturnDetails>(this.getDetailDeniedJson));
    }
    if (original?.returnStatus === 'Return Orphan') {
      return lastValueFrom(this.http.get<IRtpInitiatedReturnDetails>(this.getDetailOrphanJson));
    }
    if (original?.returnStatus === 'Return Initiated') {
      return lastValueFrom(this.http.get<IRtpInitiatedReturnDetails>(this.getDetailInitiatedJson));
    }
    return lastValueFrom(this.http.get<IRtpInitiatedReturnDetails>(this.getDetailInitiatedJson));
  }

  getDetailFromTransaction(
    rtpUniqueMessageId: string
  ): Promise<IRtpInitiatedReturnDetails | undefined> {
    throw new Error('Method not implemented.');
  }

  initiate(initiateReturn: IReturnInitiate): Promise<IWebMessage | undefined> {
    return lastValueFrom(this.http.get<IWebMessage>(this.initiateJson));
  }

  reasonInitiateReturnList(rtpUniqueMessageId: string): Promise<any> {
    return lastValueFrom(this.http.get<any>(this.reasonInitiateReturnListJson));
  }

  fraudClassifierList(): Promise<any> {
    return lastValueFrom(this.http.get<any>(this.fraudClassifierListJson));
  }
}
